// extracted by mini-css-extract-plugin
export default {"defaults":"Separator_defaults__Z6MK-"};